import React from 'react';
import BasicLink from './BasicLink';

export default function LinkList({ links }) {
  if (!links || !links.length) return null;

  return (
    <ul className="bare-list with-tooltip">
      {links.map(link => (
        <li key={link.id}>
          <BasicLink to={link.url} target="_blank" external>
            <span>{link.name}</span>
          </BasicLink>
        </li>
      ))}
    </ul>
  );
}



// WEBPACK FOOTER //
// ./src/universal/ui/components/LinkList.js